export default __webpack_public_path__ + "static/MediaContentFiftTeen-16d2d78c55c0af98785e008045bf778c.webp";